import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFailoverH72(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72",
    height: "72",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.08 48.75a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M57.41 11.41a2.25 2.25 0 1 1 3.18 3.181l-4.074 4.074a38.3 38.3 0 0 1 7.362 6.055 2.25 2.25 0 0 1-3.27 3.092 33.8 33.8 0 0 0-7.365-5.874l-5.54 5.54a26.3 26.3 0 0 1 7.427 5.486 2.25 2.25 0 0 1-3.27 3.092 21.8 21.8 0 0 0-7.237-5.047 2 2 0 0 1-.295-.156l-6.044 6.044a17.26 17.26 0 0 1 10.285 5.25 2.25 2.25 0 0 1-3.27 3.092 12.75 12.75 0 0 0-11.58-3.778l-17.128 17.13a2.25 2.25 0 0 1-3.182-3.181zM33.808 24.846a2.251 2.251 0 0 1 .386 4.484 21.75 21.75 0 0 0-14.044 6.836 2.25 2.25 0 0 1-3.29-3.069 26.25 26.25 0 0 1 16.948-8.251M35.95 12.75a38.3 38.3 0 0 1 7.483.712 2.25 2.25 0 0 1-.865 4.416 33.743 33.743 0 0 0-19.994 2.195 33.75 33.75 0 0 0-11.173 7.91 2.25 2.25 0 0 1-3.29-3.069A38.26 38.26 0 0 1 35.948 12.75"
  }));
}
var IcFailoverH72 = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFailoverH72));

export { IcFailoverH72 as I };
